// ProgressBar Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import prefixer from '../../../lib/prefixer.jsx'

class ProgressBar extends Component {
  static get propTypes () {
    return {
      className: PropTypes.string,
      max: PropTypes.number,
      min: PropTypes.number,
      mode: PropTypes.oneOf(['determinate', 'indeterminate']),
      multicolor: PropTypes.bool,
      value: PropTypes.number,
      type: PropTypes.oneOf(['linear', 'circular']),
      buffer: PropTypes.number,
      formatOverdue: PropTypes.bool,
      secondary: PropTypes.bool,
      labelPosition: PropTypes.oneOf(['top', 'bottom'])
    }
  }

  static get defaultProps () {
    return {
      className: '',
      max: 100,
      min: 0,
      mode: 'indeterminate',
      multicolor: false,
      value: 0,
      type: 'circular',
      buffer: 0,
      formatOverdue: false,
      secondary: false,
      labelPosition: 'bottom'
    }
  }

  render () {
    const {
      className,
      max,
      min,
      mode,
      multicolor,
      value,
      type,
      formatOverdue,
      secondary,
      labelPosition
    } = this.props
    const _className = classnames(
      `progress-bar-${type}`,
      {
        [`progress-bar-${mode}`]: mode,
        'progress-bar-multicolor': multicolor,
        'progress-bar-warning': value > 100,
        'progress-bar-overdue': formatOverdue && value > 100,
        'progress-bar-secondary': secondary
      },
      className
    )

    return (
      <div
        data-react-toolbox='progress-bar'
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
        className={_className}
      >
        {labelPosition === 'top' && this._renderInfo()}
        {type === 'circular' ? this._renderCircular() : this._renderLinear()}
        {labelPosition === 'bottom' && this._renderInfo()}
      </div>
    )
  }

  /* Private function */
  _calculateRatio (value) {
    if (value < this.props.min) return 0
    if (value > this.props.max) return 1
    return (value - this.props.min) / (this.props.max - this.props.min)
  }

  _circularStyle () {
    if (this.props.mode !== 'indeterminate') {
      return {
        strokeDasharray: `${
          2 * Math.PI * 25 * this._calculateRatio(this.props.value)
        }, 400`
      }
    }

    return ''
  }

  _renderCircular () {
    return (
      <svg className='progress-bar-circle' viewBox='0 0 60 60'>
        <circle
          className='progress-bar-path'
          style={this._circularStyle()}
          cx='30'
          cy='30'
          r='25'
        />
      </svg>
    )
  }

  _linearStyle () {
    if (this.props.mode !== 'indeterminate') {
      let value = this.props.value
      if (this.props.formatOverdue && value > 100) {
        value = value < 200 ? value - 100 : 100
      }

      return {
        buffer: prefixer({
          transform: `scaleX(${this._calculateRatio(this.props.buffer)})`
        }),
        value: prefixer({
          transform: `scaleX(${this._calculateRatio(value)})`
        })
      }
    }

    return ''
  }

  _renderLinear () {
    const { buffer, value } = this._linearStyle()

    return (
      <div className='progress'>
        <span className='progress-bar-buffer' style={buffer} />
        <span className='progress-bar-value' style={value} />
      </div>
    )
  }

  _renderInfo () {
    return (
      <span className='progressinfo'>
        {this.props.value ? this.props.value : 0}
        <span className='infosymbol'>%</span>
      </span>
    )
  }
}

export default ProgressBar
